/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Sync_ConfirmInputs */

const vi_expense_sync_confirm = /** @type {(inputs: Expense_Sync_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo khoản chi`)
};

/**

* @param {Expense_Sync_ConfirmInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_sync_confirm = /** @type {((inputs?: Expense_Sync_ConfirmInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Sync_ConfirmInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_sync_confirm(inputs)
});